import _ from 'lodash';

/**
 * @typedef {(options: any, id: string, didUpdate?: () => void)} LoadTimetable
 */

/**
 * @param {string} nodeEnv
 * @param {string} url
 * @returns If true, the timetable should use prepopulated dev mode options and load timetable.
 *   If false, the timetable is in embed mode and should wait for options to be posted before loading
 *   timetable.
 */
export function doUseDevModeInstedOfWaitingForOptions(nodeEnv, url) {
  const urlObj = new URL(url);
  return (
    (nodeEnv === 'development' || urlObj.searchParams.get('devMode')) &&
    !urlObj.searchParams.get('embed')
  );
}

/**
 * Once the timeout is reached, a div will be appended to the page warning the user that something
 * might be wrong with timetable.
 *
 * @param {number} timeoutMs
 * @returns {number} Timeout ID. Clear this when Timetable has loaded
 */
export function showTimetableTakingAWhileToLoadOnTimeout(timeoutMs = 10000) {
  return window.setTimeout(() => {
    const warningMessage = document.createElement('div');
    warningMessage.className = 'warning';
    warningMessage.innerText =
      'The timetable is taking a while to load. If the problem persists, try loading this page in a different browser.';
    const rootNode = document.getElementById('root');
    while (rootNode.firstChild) {
      rootNode.removeChild(rootNode.firstChild);
    }
    rootNode.appendChild(warningMessage);
  }, timeoutMs);
}

/**
 * @param {MessageEvent<any>} messageEvent
 * @returns {{ isOptions: true, options: any } | { isOptions: false }}
 */
export function parseOptionsFromIframePostMessage(messageEvent) {
  // this is to check that the request is made from an iframe containing the object that we require
  // and not some other erroneous request such as an empty string or a redux dev tool request.
  if (!messageEvent.data || !_.isString(messageEvent.data)) {
    return { isOptions: false };
  } else {
    try {
      return { isOptions: true, options: JSON.parse(messageEvent.data) };
    } catch (error) {
      console.error('Timetable options parsing error:', error);
      return { isOptions: false };
    }
  }
}
